"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Loader {
    constructor(handle) {
        this.cache = new Map();
        this.data = new Map();
        this.handle = handle;
    }
    async _handle(key) {
        return this.handle(key)
            .then((result) => {
            this.data.set(key, result);
            return result;
        })
            .catch((err) => {
            this.cache.delete(key);
            throw err;
        });
    }
    async load(key) {
        if (!this.cache.has(key)) {
            this.cache.set(key, this._handle(key));
        }
        return this.cache.get(key);
    }
    isLoading(key) {
        return this.cache.has(key) && !this.data.has(key);
    }
    get size() {
        return this.data.size;
    }
    set(key, value) {
        this.cache.set(key, Promise.resolve(value));
        this.data.set(key, value);
    }
    clear(key) {
        this.data.delete(key);
        return this.cache.delete(key);
    }
    clearAll() {
        if (this.cache.size > 0) {
            this.cache = new Map();
            this.data = new Map();
            return true;
        }
        else {
            return false;
        }
    }
}
exports.default = Loader;
